import {takeLatest, put, all, call} from 'redux-saga/effects';
import {successToast} from '../actions';
import * as AC from '../actions/actionTypes';
import {
  addElevatorApi,
  configureElevatorApi,
  deleteElevatorApi,
  editElevatorApi,
  getAllElevatorsApi,
  getElevatorByIdApi,
  getElevatorConfigurationApi,
  getElevatorsApi,
  getElevatorsByBuildingApi,
  getElevatorsByEntranceApi,
  getInactiveElevatorsApi,
} from '../api/elevators.service';
import history from '../routes/history';
import {errorHandler} from '../utils/errorHandler';

function* getElevatorsSaga(fn) {
  try {
    const response = yield call(getElevatorsApi, fn.filters);
    yield put({type: AC.GET_ELEVATORS_SUCCEED, payload: response.data});
  } catch (e) {
    yield errorHandler(e, AC.GET_ELEVATORS_FAILED);
  }
}

function* getAllElevatorsSaga(fn) {
  try {
    const response = yield call(getAllElevatorsApi, fn.filters);
    yield put({type: AC.GET_ALL_ELEVATORS_SUCCEED, payload: response.data});
  } catch (e) {
    yield errorHandler(e, AC.GET_ALL_ELEVATORS_FAILED);
  }
}

function* getInactiveElevatorsSaga(fn) {
  try {
    const response = yield call(getInactiveElevatorsApi, fn.filters);
    yield put({type: AC.GET_INACTIVE_ELEVATORS_SUCCEED, payload: response.data});
  } catch (e) {
    yield errorHandler(e, AC.GET_INACTIVE_ELEVATORS_FAILED);
  }
}

function* getBuildingElevatorsSaga(fn) {
  try {
    const response = yield call(
      getElevatorsByBuildingApi,
      fn.buildingId,
      fn.filters,
    );
    yield put({
      type: AC.GET_BUILDING_ELEVATORS_SUCCEED,
      payload: response.data,
    });
  } catch (e) {
    yield errorHandler(e, AC.GET_BUILDING_ELEVATORS_FAILED);
  }
}

function* getEntranceElevatorsSaga(fn) {
  try {
    const response = yield call(
      getElevatorsByEntranceApi,
      fn.entranceId,
      fn.filters,
    );
    yield put({
      type: AC.GET_ENTRANCE_ELEVATORS_SUCCEED,
      payload: response.data,
    });
  } catch (e) {
    yield errorHandler(e, AC.GET_ENTRANCE_ELEVATORS_FAILED);
  }
}

function* getElevatorDetailsSaga(fn) {
  try {
    const response = yield call(getElevatorByIdApi, fn.id);
    yield put({type: AC.GET_ELEVATOR_DETAILS_SUCCEED, payload: response.data});
  } catch (e) {
    yield errorHandler(e, AC.GET_ELEVATOR_DETAILS_FAILED);
  }
}

function* addElevatorSaga(fn) {
  try {
    const response = yield call(addElevatorApi, fn.payload);
    yield put({
      type: AC.ADD_ELEVATOR_SUCCEED,
      payload: response.data,
      buildingId: response.data.buildingId,
      entranceId: response.data.entranceId,
      filters: {},
    });
    yield put(successToast('Elevator created successfully!'));
  } catch (e) {
    yield errorHandler(e, AC.ADD_ELEVATOR_FAILED);
  }
}

function* editElevatorSaga(fn) {
  try {
    const response = yield call(editElevatorApi, fn.payload);
    yield put({
      type: AC.EDIT_ELEVATOR_SUCCEED,
      payload: response.data,
      id: fn.payload.id,
    });
    yield put(successToast('Elevator edited successfully!'));
  } catch (e) {
    yield errorHandler(e, AC.EDIT_ELEVATOR_FAILED);
  }
}

function* deleteElevatorSaga(fn) {
  try {
    const response = yield call(deleteElevatorApi, fn.id);
    yield put({type: AC.DELETE_ELEVATOR_SUCCEED, payload: response.data});
    yield put(successToast('Elevator deleted successfully!'));
    history.back();
  } catch (e) {
    yield errorHandler(e, AC.DELETE_ELEVATOR_FAILED);
  }
}

function* getElevatorConfigurationsSaga(fn) {
  try {
    const response = yield call(getElevatorConfigurationApi, fn.id);
    yield put({
      type: AC.GET_ELEVATOR_CONGIFURATIONS_SUCCEED,
      payload: response.data,
    });
  } catch (e) {
    yield errorHandler(e, AC.GET_ELEVATOR_CONGIFURATIONS_FAILED);
  }
}

function* configureElevatorSaga(fn) {
  try {
    const response = yield call(
      configureElevatorApi,
      fn.id,
      fn.payload,
      fn.sms_username,
      fn.sms_password,
    );
    yield put({
      type: AC.CONFIGURE_ELEVATOR_SUCCEED,
      payload: response.data,
      id: fn.id,
    });
    yield put(successToast('Elevator configured successfully!'));
  } catch (e) {
    yield errorHandler(e, AC.CONFIGURE_ELEVATOR_FAILED);
  }
}

function* actionWatcher() {
  yield takeLatest(
    [AC.GET_ELEVATORS_REQUEST, AC.ADD_ELEVATOR_SUCCEED],
    getElevatorsSaga,
  );
  yield takeLatest(
    [AC.GET_BUILDING_ELEVATORS_REQUEST, AC.ADD_ELEVATOR_SUCCEED],
    getBuildingElevatorsSaga,
  );
  yield takeLatest(
    [AC.GET_ELEVATOR_DETAILS_REQUEST, AC.EDIT_ELEVATOR_SUCCEED],
    getElevatorDetailsSaga,
  );
  yield takeLatest(AC.GET_ALL_ELEVATORS_REQUEST, getAllElevatorsSaga);
  yield takeLatest(AC.GET_INACTIVE_ELEVATORS_REQUEST, getInactiveElevatorsSaga);
  yield takeLatest(AC.ADD_ELEVATOR_REQUEST, addElevatorSaga);
  yield takeLatest(AC.EDIT_ELEVATOR_REQUEST, editElevatorSaga);
  yield takeLatest(AC.DELETE_ELEVATOR_REQUEST, deleteElevatorSaga);
  yield takeLatest(
    [AC.GET_ENTRANCE_ELEVATORS_REQUEST, AC.ADD_ELEVATOR_SUCCEED],
    getEntranceElevatorsSaga,
  );
  yield takeLatest(
    [AC.GET_ELEVATOR_CONGIFURATIONS_REQUEST, AC.CONFIGURE_ELEVATOR_SUCCEED],
    getElevatorConfigurationsSaga,
  );
  yield takeLatest(AC.CONFIGURE_ELEVATOR_REQUEST, configureElevatorSaga);
}

export default function* elevatorsSaga() {
  yield all([actionWatcher()]);
}
